(() => {
  const storageKey = 'squizy-favorites-v1';

  const readFavorites = () => {
    try {
      const savedFavorites = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(savedFavorites) ? savedFavorites : [];
    } catch {
      return [];
    }
  };

  const writeFavorites = (favorites) => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(favorites));
      document.dispatchEvent(new CustomEvent('squizy:favorites-updated', { detail: { favorites } }));
    } catch {
      return;
    }
  };

  const syncFavoriteButtons = () => {
    const favorites = readFavorites();

    document.querySelectorAll('[data-squizy-favorite]').forEach((button) => {
      const isFavorite = favorites.includes(button.dataset.productHandle);
      button.classList.toggle('is-favorite', isFavorite);
      button.setAttribute('aria-pressed', String(isFavorite));
      button.setAttribute('aria-label', isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris');
    });

    document.querySelectorAll('[data-squizy-favorites-link]').forEach((link) => {
      link.classList.toggle('has-favorites', favorites.length > 0);
      link.setAttribute('aria-label', favorites.length ? `Favoris (${favorites.length})` : 'Favoris');
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-squizy-favorite]');
    if (!button) return;

    const handle = button.dataset.productHandle;
    if (!handle) return;

    const favorites = readFavorites();
    const favoriteIndex = favorites.indexOf(handle);

    if (favoriteIndex === -1) {
      favorites.push(handle);
    } else {
      favorites.splice(favoriteIndex, 1);
    }

    writeFavorites(favorites);
    syncFavoriteButtons();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) syncFavoriteButtons();
  });

  syncFavoriteButtons();
})();
